<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card class="card-plain">
          <!-- <template slot="header">
            <h4 class="card-title">Table on Plain Background</h4>
            <p class="category">Here is a subtitle for this table</p>
          </template>-->
          <div class="table-full-width text-left">
            <field-table
            v-if="fields && fields.length > 0"
				:title="table1.title"
				:sub-title="table1.subTitle"
				:fields="fields"
				:totalElements="totalElements"
				:page="page"
				:columns="table1.columns"
 				@get-all-fields="getAllFields"
             >

            </field-table>
          </div>
        </card>
      </div>

    </div>
  </div>
</template>
<script>
import { Card } from "@/components/Card";

import FieldTable from "@/components/FieldTable";
import FieldService from "../services/FieldService";

const tableColumns = [];
const tableData = [
];

export default {
  components: {
    Card,
    FieldTable,
  },
  data() {
    return {
      fields: [],
	  totalElements: 0,
      page: 0,
      searchQuery: '',     
      table1: {
        title: "Simple Table",
        columns: [...tableColumns],
        data: [...tableData],
      },
    };
  },
  methods: {
    async getAllFields(sortBy='fieldId',sortOrder='true',page="0",size="50") {
      try {
        try {
			const searchDTO = {
				sortBy: sortBy, 
				sortOrder: sortOrder, 
				searchQuery: this.searchQuery,
				page: page, 
				size: size
			};
	        let response = await FieldService.getAllFields(searchDTO);
	        if (!response.data.empty) {
		        if (response.data.fields.length) {
					this.fields = response.data.fields;
				}
      			this.totalElements = response.data.totalElements;
      			this.page = response.data.page;
	        }
        } catch (error) {
          console.error("Error fetching fields:", error);
        }
        
      } catch (error) {
        console.error("Error fetching field details:", error);
      }
    },
  },
  mounted() {
    this.getAllFields();
  },
  created() {
    this.$root.$on('searchQueryForFieldsChanged', (searchQuery) => {
    	this.searchQuery = searchQuery;
    	this.getAllFields();
    })
  }
};
</script>
<style></style>
